module.exports = __webpack_public_path__ + "static/pme_lider_25-d26d3ef69c87f6d934a3ede89647f8bd.png";